import useThemeStore from "../store/useThemeStore";

/**
 * Active theme from the shared store. applyTheme() keeps this in sync with
 * html[data-theme], including marketing pages that force light.
 */
export function useEffectiveTheme() {
  return useThemeStore((state) => state.isDark);
}
